export const USER_PROFILE_ONBOARDING_STATES = {
  DESKTOP_ONBOARDING: 'desktop_onboarding',
  DESKTOP_ONBOARDING_COMPLETED: 'desktop_onboarding_completed',
  DESKTOP_ONBOARDING_SKIPPED: 'desktop_onboarding_skipped',
};
